import { createFeatureSelector, createSelector } from "@ngrx/store";
import { dataSourceFeatureKey } from "./data-source.reducer";

export const selectDataSourceState = createFeatureSelector(dataSourceFeatureKey);

export const selectDataSource = createSelector(
  selectDataSourceState,
  (state: any) => state
);